<template>
    <div>
        <b-row>
            <b-col class="col-xxl-10 col-xl-9 col-lg-8 col-md-12 col-sm-12 mb-4">
                <calendar @date-changed="handleDateChangedTrigger" :title="pageTitle"></calendar>
            </b-col>

            <b-col class="col-xxl-2 col-xl-3 col-lg-4 col-md-12 col-sm-12 mb-4">
                <div class="control-wrapper card">
                    <b-row>
                        <b-col class="col-xl-12 col-lg-12 col-md-6 mt-2 mb-2">
                            <export
                                :range-name="String(currentRangeName)"
                                :company-title="company.name"
                            ></export>
                        </b-col>

                        <b-col class="col-xl-12 col-lg-12 col-md-6 mt-2 mb-2">
                            <b-dropdown
                                v-if="canSwitchClient"
                                variant="outline-primary"
                                text="View analytics for"
                                class="role-picker"
                            >
                                <b-dropdown-item href="/analytics">All clients</b-dropdown-item>
                                <b-dropdown-item
                                    :href="'/analytics/' + customer.slug"
                                    v-for="customer in clients"
                                    :key="customer.id"
                                    >{{ customer.name }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <tally></tally>
            </b-col>
        </b-row>

        <b-row class="mb-4">
            <b-col md="12">
                <analytics-matrix :range="`currentRangeName`"></analytics-matrix>
            </b-col>
        </b-row>

        <b-row class="mb-2 mt-2">
            <b-col class="mb-4 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <b-card no-body class="card-container">
                    <template v-slot:header>
                        <h4>Pass Rate for {{ currentRangeName }}</h4>
                    </template>

                    <b-card-body>
                        <pass-rate-container :range="`currentRangeName`"></pass-rate-container>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col class="mb-4 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <b-card no-body class="card-container">
                    <template v-slot:header>
                        <h4>Total Exports for {{ currentRangeName }} </h4>
                    </template>

                    <b-card-body>
                        <monthly-exports-container
                            :range="`currentRangeName`"
                        ></monthly-exports-container>
                    </b-card-body>
                </b-card>
            </b-col>

            <b-col class="mb-4 col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <b-card no-body class="card-container">
                    <template v-slot:header>
                        <h4>Fail Category Spread for {{ currentRangeName }}</h4>
                    </template>

                    <b-card-body>
                        <fail-category-container></fail-category-container>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>

</template>

<script>
import Calendar from "./Calendar/Calendar";
import Export from "./Export/ExportComponent";
import MonthlyExportsContainer from "./MonthlyExportsContainer";
import PassRateContainer from "./PassRateContainer";
import FailCategoryContainer from "./FailCategoryContainer";
import Tally from "./Tally";
import axios from "axios";
import moment from "moment";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    FailCategoryContainer,
    PassRateContainer,
    MonthlyExportsContainer,
    Calendar,
    Export,
    Tally
  },
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("en-US", options).format(value);
    }
  },
  props: {
    mode: {
      type: String,
      required: true
    },
    client: {
      type: Number,
      default: null
    },
    company: {
      type: Object,
      default: null
    },
    canSwitchClient: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clients: [],
      currentRangeName: "This month",
      unit: "month",
      currentClient: null
    };
  },
  computed: {
    pageTitle() {
      let title = "Analytics";

      if (this.currentClient) {
        title += " for " + this.currentClient.name;
      }

      return title;
    }
  },
  created() {
    if (this.mode != "service provider") {
      this.$store.commit("analytics/setClientFilter", this.company.id);
    } else {
      this.$store.commit("analytics/setClientFilter", this.client);
    }
  },
  mounted() {
    if (this.canSwitchClient) {
      this.getClients();
    }
  },
  methods: {
    handleDateChangedTrigger(event) {
      this.updateLocationParams(event);
    },
    updateLocationParams(params) {
      this.currentRangeName = params.rangeTitle;

      this.$store.commit("analytics/setDates", {
        start_date: params.startDate,
        end_date: params.endDate,
        unit: params.unit
      });

      this.reRender();
    },
    reRender() {
      this.$root.$emit("passRate");
      this.$root.$emit("failCat");
      this.$root.$emit("montlyExp");
      this.$root.$emit("tallySt");
    },
    rangeSelectedListener(ranges, range, rangeName) {
      ranges.clickRange(range);
      this.currentRangeName = rangeName;
    },
    getClients() {
      axios.get("/api/clients").then(r => {
        this.clients = r.data.data;
        if (this.client) {
          this.currentClient = this.clients.find(c => c.id === this.client);
        }
      });
    }
  }
};
</script>

<style scoped>
h4 {
  margin-top: 0.5rem;
}

.control-wrapper {
  padding-left: 10px;
  padding-right: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.role-picker {
  width: 100%;
}

.calendar-area {
  background-color: white;
  padding: 10px;
}
</style>
